import { NavigationGuard } from 'vue-router';
import store from '@/store';
import { redirect } from '@/helpers/redirects';
import { checkJwtRoles } from './helpers';

export const requireProvider: NavigationGuard = (_to, _from, next) => {
  const account = store.getters['account/getAccount'];

  // If store account is not available, check JWT data directly
  if (!account || typeof account.isSitter !== 'function') {
    const jwtCheck = checkJwtRoles();

    if (!jwtCheck.hasRoles) {
      next(false);
      redirect('/login');
      return;
    }

    if (jwtCheck.isSitter) {
      next();
    } else if (jwtCheck.isParent) {
      next('/account/seekers/dashboard');
    } else {
      next(false);
      redirect('/login');
    }
    return;
  }

  if (account.isSitter()) {
    next();
  } else {
    next('/account/seekers/dashboard');
  }
};

export const requireSeeker: NavigationGuard = (_to, _from, next) => {
  const account = store.getters['account/getAccount'];

  if (!account || typeof account.isParent !== 'function') {
    const jwtCheck = checkJwtRoles();

    if (!jwtCheck.hasRoles) {
      next(false);
      redirect('/login');
      return;
    }

    if (jwtCheck.isParent) {
      next();
    } else if (jwtCheck.isSitter) {
      next('/account/providers/dashboard');
    } else {
      next(false);
      redirect('/login');
    }
    return;
  }

  if (account.isParent()) {
    next();
  } else {
    next('/account/providers/dashboard');
  }
};

export const requirePremium: NavigationGuard = (_to, _from, next) => {
  const account = store.getters['account/getAccount'];

  if (!account || typeof account.isPremium !== 'function') {
    const jwtCheck = checkJwtRoles();

    if (!jwtCheck.hasRoles) {
      // next(false) aborts the current Vue Router navigation to prevent UI flash
      // redirect() then performs a full-page redirect to /login
      next(false);
      redirect('/login');
      return;
    }

    if (jwtCheck.isPremium) {
      next();
    } else {
      // next(false) aborts the current Vue Router navigation to prevent UI flash
      // redirect() then performs a full-page redirect to /login
      next(false);
      redirect('/login');
    }
    return;
  }

  if (account.isPremium()) {
    next();
  } else {
    next('/upgrade');
  }
};

export const requireFamilyConcierge: NavigationGuard = (_to, _from, next) => {
  const account = store.getters['account/getAccount'];

  // If store account is not available, check JWT data directly
  if (!account || typeof account.isFamilyConcierge !== 'function') {
    const jwtCheck = checkJwtRoles();

    if (!jwtCheck.hasRoles) {
      next(false);
      redirect('/login');
      return;
    }

    if (jwtCheck.isFamilyConcierge) {
      next();
    } else if (jwtCheck.isSitter) {
      next('/account/providers/dashboard');
    } else {
      next('/account/seekers/dashboard');
    }
    return;
  }

  if (account.isFamilyConcierge()) {
    next();
  } else if (account.isSitter()) {
    next('/account/providers/dashboard');
  } else {
    next('/account/seekers/dashboard');
  }
};

export const requireAuthenticated: NavigationGuard = (_to, _from, next) => {
  const account = store.getters['account/getAccount'];

  // If store account is not available, check JWT data directly
  if (!account || (typeof account.isSitter !== 'function' && typeof account.isParent !== 'function')) {
    const jwtCheck = checkJwtRoles();

    if (!jwtCheck.hasRoles) {
      next(false);
      redirect('/login');
      return;
    }

    // Allow any authenticated user (seeker or provider)
    next();
    return;
  }

  // Allow any authenticated user (seeker or provider)
  if (account.isSitter?.() || account.isParent?.()) {
    next();
  } else {
    next(false);
    redirect('/login');
  }
};
